module.exports = __webpack_public_path__ + "static/land-ee604447365bb53af7d7bc719737d789.jpg";